<template>
  <div>
    <ys-data-table
      v-model="refresh"
      :list="searchList"
      :button-list="buttonList"
      :columns="columns"
      :fetch-method="fetchMethod"
      :transform-params="handleFormatSearch"
      :use-pagination="false"
      use-data-field
    >
      <template slot="supply_id" slot-scope="{ row }">
        <div>
          {{ row.supply_id.join(",") }}
        </div>
      </template>
      <template slot="actions" slot-scope="{ row }">
        <div style="display: flex">
          <el-button
            type="text"
            size="normal"
            @click="handleDialogAddOpen(row)"
          >
            查看合同内容
          </el-button>
          <el-button
            type="text"
            size="normal"
            @click="handleDialogOpen(row.cp_id)"
            >查看签署情况</el-button
          >
          <el-button
            v-if="row.status !== STATUS_CLOSE"
            type="text"
            @click="handleCloseContract(row.cp_id)"
            >关闭推送</el-button
          >
        </div>
      </template>
      <template slot="addContractPush">
        <el-button type="primary" @click="dialogVisibleAdd = true">
          新增合同推送
        </el-button>
      </template>
    </ys-data-table>
    <el-dialog
      title="查看签署状态"
      :visible.sync="dialogVisible"
      @close="handleDialogClose"
    >
      <el-table :data="logTableData" border>
        <el-table-column prop="supply_id" label="商家ID"> </el-table-column>
        <el-table-column prop="supply_name" label="商家名称"> </el-table-column>
        <el-table-column prop="is_sign" label="是否签署"> </el-table-column>
        <el-table-column prop="sign_time" label="签署时间"> </el-table-column>
      </el-table>
      <template slot="footer">
        <el-button type="primary" @click="handleDialogClose">确定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      title="新建合同"
      :visible.sync="dialogVisibleAdd"
      :close-on-click-modal="false"
      @close="handleDialogAddClose"
    >
      <el-form>
        <el-form-item label="合同名称:" required>
          <el-input
            v-model="addContractForm.sc_name"
            placeholder="请输入合同名称"
            style="width: 300px"
            :disabled="isLookContract"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同开始时间:" required>
          <el-radio
            v-model="addContractForm.start_time_type"
            :disabled="isLookContract"
            :label="IMMEDIATE"
            >签署立即生效</el-radio
          >
          <el-radio
            v-model="addContractForm.start_time_type"
            :label="SPECIFIED"
            :disabled="isLookContract"
          >
            按指定时间
            <el-date-picker
              v-model="addContractForm.start_time"
              :disabled="isLookContract"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择合同签署时间"
            >
            </el-date-picker
          ></el-radio>
        </el-form-item>
        <el-form-item label="合同结束时间:" required>
          <el-date-picker
            v-model="addContractForm.end_time"
            :disabled="isLookContract"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择合同签署时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商家id:" required>
          <el-input
            v-model="addContractForm.supply_list"
            type="textarea"
            :disabled="isLookContract"
            placeholder="一行一个id"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同内容:" required>
          <vue-editor
            v-model="addContractForm.sc_content"
            :disabled="isLookContract"
          ></vue-editor>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="text" @click="handleDialogAddClose">取消</el-button>
        <el-button
          type="primary"
          :disabled="isLookContract"
          @click="handleDialogAddSubmit"
          >确定</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import VueEditor from "yimo-vue-editor";
import {
  getSupplyContractSign,
  listSupplyContractPush,
  saveSupplyContractPush,
  cancelSupplyContractPush,
  getSupplyContractContent,
} from "@/controller/supplyContract.js";

const IMMEDIATE = "1";
const SPECIFIED = "2";
const STATUS_CLOSE = "0";

export default {
  name: "OnlineContractManagement",
  components: {
    VueEditor,
  },
  props: {
    originId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      IMMEDIATE,
      SPECIFIED,
      STATUS_CLOSE,
      mergeForm: {
        origin_id: "",
      },
      columns: [
        {
          label: "记录ID",
          prop: "cp_id",
          width: "80",
        },
        {
          label: "合同名称",
          prop: "sc_name",
        },
        {
          label: "生效起止时间",
          prop: "effect_time",
        },
        {
          label: "推送商家ID",
          slot: "supply_id",
        },
        {
          label: "状态",
          prop: "status_name",
          width: "80",
        },
        {
          label: "创建人/时间",
          prop: "created_time_admin",
        },
        {
          label: "更新人/时间",
          prop: "updated_time_admin",
        },
        {
          label: "操作",
          width: "280",
          slot: "actions",
        },
      ],
      dialogVisible: false,
      fetchMethod: listSupplyContractPush,
      buttonList: [
        {
          tag: "custom",
          slot: "addContractPush",
        },
      ],
      searchList: [
        {
          tag: "input",
          label: "记录ID",
          field: "cp_id",
          props: {
            pattern: "digit",
          },
        },
        {
          tag: "input",
          label: "合同名称",
          field: "sc_name",
        },
        {
          tag: "input",
          label: "商家ID",
          field: "supply_id",
          props: {
            pattern: "digit",
          },
        },
        {
          tag: "select",
          label: "状态",
          field: "status",
          options: [
            {
              label: "开启中",
              value: "1",
            },
            {
              label: "已关闭",
              value: "0",
            },
          ],
        },
        {
          tag: "date",
          label: "创建时间",
          field: "create_time",
          props: {
            type: "daterange",
            placeholder: "请选择",
            clearable: false,
            defaultTime: ["00:00:00", "23:59:59"],
          },
          transform: (value = []) => {
            if (value?.length) {
              return {
                create_time: [
                  dayjs(value[0]).format("YYYY-MM-DD 00:00:00"),
                  dayjs(value[1]).format("YYYY-MM-DD 23:59:59"),
                ],
              };
            }
          },
        },
      ],
      refresh: false,
      logTableData: [],
      addContractForm: {
        sc_name: "",
        supply_list: "",
        start_time_type: IMMEDIATE,
        start_time: "",
        end_time: "",
        sc_content: "",
      },
      dialogVisibleAdd: false,
      isLookContract: false,
    };
  },
  watch: {
    "addContractForm.start_time_type": function (val) {
      if (val === IMMEDIATE) {
        this.addContractForm.start_time = "";
      }
    },
  },
  created() {
    this.refresh = true;
  },
  methods: {
    handleFormatSearch(params) {
      const result = {
        ...this.mergeForm,
        ...params,
      };
      return result;
    },

    // 查看日志
    handleDialogOpen(cp_id) {
      getSupplyContractSign({ cp_id }).then((data) => {
        this.logTableData = data;
        this.dialogVisible = true;
      });
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.isLookContract = false;
    },
    // 新建合同
    handleDialogAddSubmit() {
      if (this.addContractForm.sc_name.length > 15) {
        return this.$message.info("合同名称过长，请检查");
      }
      if (
        this.addContractForm.start_time_type === SPECIFIED &&
        !this.addContractForm.start_time
      ) {
        return this.$message.info("必须选择指定时间");
      }
      const params = {
        ...this.addContractForm,
      };
      params.supply_list = this.addContractForm.supply_list.split("\n");
      saveSupplyContractPush(params).then(() => {
        this.$message.success("新建成功");
        this.refresh = true;
        this.dialogVisibleAdd = false;
      });
    },
    // 查看合同
    handleDialogAddOpen(row) {
      getSupplyContractContent({ cp_id: row.cp_id }).then((data) => {
        this.addContractForm = data;
        this.dialogVisibleAdd = true;
        this.isLookContract = true;
        this.addContractForm = {
          sc_name: row.sc_name,
          supply_list: row.supply_id.join(","),
          start_time_type: row.start_time_type,
          start_time: row.start_time,
          end_time: row.end_time,
          sc_content: data.content,
        };
      });
    },
    // 关闭合同
    handleCloseContract(cp_id) {
      cancelSupplyContractPush({ cp_id }).then(() => {
        this.refresh = true;
        this.$message.success("关闭成功");
      });
    },
    handleDialogAddClose() {
      this.dialogVisibleAdd = false;
      this.isLookContract = false;
      this.addContractForm = this.$options.data().addContractForm;
    },
  },
};
</script>

<style lang="" scoped></style>



// WEBPACK FOOTER //
// src/pages/supply/OnlineContractManagement.vue